import { render } from "./PreviousDrawCard.vue?vue&type=template&id=73a34374&scoped=true&ts=true"
import script from "./PreviousDrawCard.vue?vue&type=script&lang=ts"
export * from "./PreviousDrawCard.vue?vue&type=script&lang=ts"

import "./PreviousDrawCard.vue?vue&type=style&index=0&id=73a34374&scoped=true&lang=scss"

import exportComponent from "/var/www/rewards/runners/app/root/reward-app/reward-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73a34374"]])

export default __exports__